// Real asset map for Bendito Tattoo
export const ASSETS = {
  logoText: "BENDITO",
  // Hero — use the best portfolio piece as background
  hero: "/images/portfolio/eeme_floral.jpeg",
  // Artist headshots
  artists: {
    may: "/images/artists/may.jpeg",
    eeme: "/images/artists/eeme.jpeg",
    tyson: "/images/artists/tyson.jpeg",
    alvaro: "/images/artists/alvaro.jpeg",
    avelino: "/images/artists/avelino.jpeg",
    ezzer: "/images/artists/ezzer.jpeg",
  },
  studio: [
    // Placeholder — replace with real studio photos when available
    "/images/portfolio/eeme_virgin.jpeg",
    "/images/portfolio/eeme_chichen.jpeg",
    "/images/portfolio/tyson_nose.jpeg",
  ],
};

// Portfolio items with real photos
export const PORTFOLIO = [
  {
    id: "p1",
    src: "/images/portfolio/eeme_floral.jpeg",
    cat: "fullColor",
    artist: "EEME",
    alt: "Fine line floral forearm wrap",
  },
  {
    id: "p2",
    src: "/images/portfolio/eeme_virgin.jpeg",
    cat: "fullColor",
    artist: "EEME",
    alt: "Fine line Virgin Mary with red rose",
  },
  {
    id: "p3",
    src: "/images/portfolio/eeme_chichen.jpeg",
    cat: "mayan",
    artist: "EEME",
    alt: "Micro realism Chichen Itza pyramid",
  },
  {
    id: "p55",
    src: "/images/artists/avelino/avelino_1.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Realism tattoo by Avelino",
  },
  {
    id: "p56",
    src: "/images/artists/avelino/avelino_2.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Black and grey realism by Avelino",
  },
  {
    id: "p65",
    src: "/images/artists/ezzer/ezzer_1.jpeg",
    cat: "traditional",
    artist: "Ez'zer",
    alt: "Neo traditional tattoo by Ez'zer",
  },
  {
    id: "p66",
    src: "/images/artists/ezzer/ezzer_2.jpeg",
    cat: "traditional",
    artist: "Ez'zer",
    alt: "Traditional Japanese tattoo by Ez'zer",
  },
  {
    id: "p67",
    src: "/images/artists/ezzer/ezzer_3.jpeg",
    cat: "blackwork",
    artist: "Ez'zer",
    alt: "Blackwork piece by Ez'zer",
  },
  {
    id: "p68",
    src: "/images/artists/ezzer/ezzer_4.jpeg",
    cat: "traditional",
    artist: "Ez'zer",
    alt: "Bio-organic tattoo by Ez'zer",
  },
  {
    id: "p4",
    src: "/images/portfolio/eeme_stamp.jpeg",
    cat: "traditional",
    artist: "EEME",
    alt: "Mexico postcard stamp with turtle and palm tree",
  },
  {
    id: "p5",
    src: "/images/portfolio/eeme_swallow.jpeg",
    cat: "fullColor",
    artist: "EEME",
    alt: "Traditional colorful swallow bird",
  },
  {
    id: "p6",
    src: "/images/portfolio/eeme_skull.jpeg",
    cat: "blackwork",
    artist: "EEME",
    alt: "Skull with sombrero blackwork",
  },
  {
    id: "p7",
    src: "/images/portfolio/tyson_nose.jpeg",
    cat: "piercings",
    artist: "Tyson",
    alt: "Nose piercing gold ring and stud",
  },
  {
    id: "p8",
    src: "/images/portfolio/tyson_helix.jpeg",
    cat: "piercings",
    artist: "Tyson",
    alt: "Helix piercing silver with crystal leaves",
  },
  {
    id: "p9",
    src: "/images/portfolio/tyson_conch.jpeg",
    cat: "piercings",
    artist: "Tyson",
    alt: "Conch piercing with green gem leaves",
  },
  {
    id: "p57",
    src: "/images/artists/avelino/avelino_3.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Realism portrait tattoo by Avelino",
  },
  {
    id: "p58",
    src: "/images/artists/avelino/avelino_4.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Black and grey realism piece by Avelino",
  },
  {
    id: "p10",
    src: "/images/portfolio/tyson_industrial.jpeg",
    cat: "piercings",
    artist: "Tyson",
    alt: "Industrial piercing with gemstones",
  },
  {
    id: "p11",
    src: "/images/portfolio/tyson_scarification.jpeg",
    cat: "tribal",
    artist: "Tyson",
    alt: "Facial scarification body modification",
  },
  // Alvaro Dziczek
  {
    id: "p12",
    src: "/images/portfolio/alvaro_lion.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Full back lion blackwork piece",
  },
  {
    id: "p13",
    src: "/images/portfolio/alvaro_mandala_chest.jpeg",
    cat: "geometric",
    artist: "Alvaro",
    alt: "Mandala chest piece with dotwork",
  },
  {
    id: "p14",
    src: "/images/portfolio/alvaro_maori_thigh.jpeg",
    cat: "tribal",
    artist: "Alvaro",
    alt: "Maori tribal thigh piece with plumeria flowers",
  },
  {
    id: "p69",
    src: "/images/artists/ezzer/ezzer_5.jpeg",
    cat: "neoTraditional",
    artist: "Ez'zer",
    alt: "Neo traditional color piece by Ez'zer",
  },
  {
    id: "p70",
    src: "/images/artists/ezzer/ezzer_6.jpeg",
    cat: "neoTraditional",
    artist: "Ez'zer",
    alt: "Japanese style tattoo by Ez'zer",
  },
  {
    id: "p71",
    src: "/images/artists/ezzer/ezzer_7.jpeg",
    cat: "bioOrganic",
    artist: "Ez'zer",
    alt: "Bio-organic design by Ez'zer",
  },
  {
    id: "p72",
    src: "/images/artists/ezzer/ezzer_8.jpeg",
    cat: "blackwork",
    artist: "Ez'zer",
    alt: "Blackwork traditional by Ez'zer",
  },
  {
    id: "p15",
    src: "/images/portfolio/alvaro_geometric_sleeve.jpeg",
    cat: "geometric",
    artist: "Alvaro",
    alt: "Geometric sacred geometry full sleeve",
  },
  {
    id: "p59",
    src: "/images/artists/avelino/avelino_5.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Realism detail work by Avelino",
  },
  {
    id: "p60",
    src: "/images/artists/avelino/avelino_6.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Full color realism by Avelino",
  },
  {
    id: "p16",
    src: "/images/portfolio/alvaro_dragon.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Japanese dragon full leg blackwork",
  },
  {
    id: "p17",
    src: "/images/portfolio/alvaro_maori_shoulder.jpeg",
    cat: "tribal",
    artist: "Alvaro",
    alt: "Maori tribal shoulder with dolphin and turtle",
  },
  {
    id: "p18",
    src: "/images/portfolio/alvaro_tribal_skull.jpeg",
    cat: "tribal",
    artist: "Alvaro",
    alt: "Tribal skull with lotus back piece",
  },
  {
    id: "p19",
    src: "/images/portfolio/alvaro_quetzalcoatl.jpeg",
    cat: "mayan",
    artist: "Alvaro",
    alt: "Quetzalcoatl feathered serpent with pyramid",
  },
  {
    id: "p20",
    src: "/images/portfolio/alvaro_phoenix.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Phoenix fire back piece traditional color",
  },
  {
    id: "p21",
    src: "/images/portfolio/alvaro_catrina_sombrero.jpeg",
    cat: "mayan",
    artist: "Alvaro",
    alt: "Dia de muertos sugar skull with sombrero",
  },
  {
    id: "p22",
    src: "/images/portfolio/alvaro_metatron.jpeg",
    cat: "geometric",
    artist: "Alvaro",
    alt: "Metatron cube sacred geometry chest piece",
  },
  {
    id: "p23",
    src: "/images/portfolio/alvaro_snake.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Snake shoulder to chest blackwork",
  },
  {
    id: "p24",
    src: "/images/portfolio/alvaro_samurai.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Samurai warrior with enso circle blackwork",
  },
  {
    id: "p25",
    src: "/images/portfolio/alvaro_geometric_skull.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Geometric sleeve with 3D colorful skull",
  },
  {
    id: "p26",
    src: "/images/portfolio/alvaro_aztec.jpeg",
    cat: "mayan",
    artist: "Alvaro",
    alt: "Aztec warrior with feathered headdress and wolf",
  },
  {
    id: "p27",
    src: "/images/portfolio/alvaro_mandala_back.jpeg",
    cat: "geometric",
    artist: "Alvaro",
    alt: "Mandala dotwork back and neck piece",
  },
  {
    id: "p28",
    src: "/images/portfolio/alvaro_skull_glass.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Skull in whiskey glass blackwork thigh piece",
  },
  {
    id: "p29",
    src: "/images/portfolio/alvaro_watercolor_travel.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Watercolor camera compass and airplane travel piece",
  },
  {
    id: "p61",
    src: "/images/artists/avelino/avelino_7.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Neo traditional realism by Avelino",
  },
  {
    id: "p62",
    src: "/images/artists/avelino/avelino_8.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Oriental realism tattoo by Avelino",
  },
  {
    id: "p30",
    src: "/images/portfolio/alvaro_watercolor_yinyang.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Watercolor yin yang with bonsai trees",
  },
  {
    id: "p31",
    src: "/images/portfolio/alvaro_watercolor_fox.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Pink watercolor fox forearm piece",
  },
  {
    id: "p32",
    src: "/images/portfolio/alvaro_sugar_skull.jpeg",
    cat: "fullColor",
    artist: "Alvaro",
    alt: "Colorful sugar skull with ornamental frame",
  },
  {
    id: "p33",
    src: "/images/portfolio/alvaro_geisha.jpeg",
    cat: "traditional",
    artist: "Alvaro",
    alt: "Neo-traditional geisha head tattoo with skeleton hands",
  },
  {
    id: "p34",
    src: "/images/portfolio/alvaro_snake_back.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Coiled snake full back blackwork piece",
  },
  {
    id: "p35",
    src: "/images/portfolio/alvaro_skull_bee.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Skull bee blackwork thigh piece",
  },
  {
    id: "p36",
    src: "/images/portfolio/alvaro_reaper.jpeg",
    cat: "traditional",
    artist: "Alvaro",
    alt: "Grim reaper traditional blackwork forearm",
  },
  {
    id: "p37",
    src: "/images/portfolio/alvaro_blackwork_floral.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Blackwork floral with mushroom leg piece",
  },
  {
    id: "p38",
    src: "/images/portfolio/alvaro_cathedral.jpeg",
    cat: "blackwork",
    artist: "Alvaro",
    alt: "Gothic cathedral spine blackwork piece",
  },
  {
    id: "p73",
    src: "/images/artists/ezzer/ezzer_9.jpeg",
    cat: "neoTraditional",
    artist: "Ez'zer",
    alt: "Neo traditional sleeve by Ez'zer",
  },
  {
    id: "p74",
    src: "/images/artists/ezzer/ezzer_10.jpeg",
    cat: "traditional",
    artist: "Ez'zer",
    alt: "Traditional tattoo by Ez'zer",
  },
  {
    id: "p75",
    src: "/images/artists/ezzer/ezzer_11.jpeg",
    cat: "bioOrganic",
    artist: "Ez'zer",
    alt: "Bio-organic art by Ez'zer",
  },
  {
    id: "p76",
    src: "/images/artists/ezzer/ezzer_12.jpeg",
    cat: "neoTraditional",
    artist: "Ez'zer",
    alt: "Japanese neo traditional by Ez'zer",
  },
  // May — Fine Line
  {
    id: "p39",
    src: "/images/artists/may/may_1.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line tattoo by May",
  },
  {
    id: "p40",
    src: "/images/artists/may/may_2.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line floral tattoo by May",
  },
  {
    id: "p41",
    src: "/images/artists/may/may_3.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Delicate fine line piece by May",
  },
  {
    id: "p42",
    src: "/images/artists/may/may_4.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line minimalist tattoo by May",
  },
  {
    id: "p43",
    src: "/images/artists/may/may_5.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line botanical tattoo by May",
  },
  {
    id: "p44",
    src: "/images/artists/may/may_6.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line detail work by May",
  },
  {
    id: "p45",
    src: "/images/artists/may/may_7.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line tattoo design by May",
  },
  {
    id: "p46",
    src: "/images/artists/may/may_8.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line art tattoo by May",
  },
  {
    id: "p63",
    src: "/images/artists/avelino/avelino_9.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Geometric realism by Avelino",
  },
  {
    id: "p64",
    src: "/images/artists/avelino/avelino_10.jpeg",
    cat: "realism",
    artist: "Avelino",
    alt: "Anime style tattoo by Avelino",
  },
  {
    id: "p47",
    src: "/images/artists/may/may_9.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line ornamental tattoo by May",
  },
  {
    id: "p48",
    src: "/images/artists/may/may_10.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line script tattoo by May",
  },
  {
    id: "p49",
    src: "/images/artists/may/may_11.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line nature tattoo by May",
  },
  {
    id: "p50",
    src: "/images/artists/may/may_12.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line feminine tattoo by May",
  },
  {
    id: "p51",
    src: "/images/artists/may/may_13.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line small tattoo by May",
  },
  {
    id: "p52",
    src: "/images/artists/may/may_14.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line illustrative tattoo by May",
  },
  {
    id: "p53",
    src: "/images/artists/may/may_15.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line custom tattoo by May",
  },
  {
    id: "p54",
    src: "/images/artists/may/may_16.jpeg",
    cat: "fineLine",
    artist: "May",
    alt: "Fine line precision tattoo by May",
  },
  {
    id: "p77",
    src: "/images/artists/ezzer/ezzer_13.jpeg",
    cat: "blackwork",
    artist: "Ez'zer",
    alt: "Blackwork piece by Ez'zer",
  },
  {
    id: "p78",
    src: "/images/artists/ezzer/ezzer_14.jpeg",
    cat: "neoTraditional",
    artist: "Ez'zer",
    alt: "Color neo traditional by Ez'zer",
  },
  {
    id: "p79",
    src: "/images/artists/ezzer/ezzer_15.jpeg",
    cat: "bioOrganic",
    artist: "Ez'zer",
    alt: "Bio-organic sleeve by Ez'zer",
  },
  {
    id: "p80",
    src: "/images/artists/ezzer/ezzer_16.jpeg",
    cat: "traditional",
    artist: "Ez'zer",
    alt: "Traditional Japanese art by Ez'zer",
  },
];
